import { Injectable } from "@angular/core";
import { FiltroRicercaAttoVO } from "@app/shared/vo/filtro-ricerca-attoVO";

@Injectable({
  providedIn: "root",
})
export class FiltroRicercaAttoStore {
  private filtroRicercaAtto: FiltroRicercaAttoVO;
  private filtroRicercaAvanzataAtto: FiltroRicercaAttoVO;
  private filtroRicercaSempliceAtto: FiltroRicercaAttoVO;

  constructor() {
    this.filtroRicercaAtto = null;
  }

  public setFiltroRicercaAtto(
    filtroRicercaAtto: FiltroRicercaAttoVO
  ) {
    console.log(
      "[FiltroRicercaAttoStore][setFiltroRicercaAtto]",
      filtroRicercaAtto
    );
    this.filtroRicercaAtto = filtroRicercaAtto;
  }

  public getFiltroRicercaAtto(): FiltroRicercaAttoVO {
    console.log(
      "[FiltroRicercaAttoStore][getFiltroRicercaAtto]",
      this.filtroRicercaAtto
    );
    return this.filtroRicercaAtto;
  }

  public resetFiltroAtto() {
    console.log("[FiltroRicercaAttoStore][resetTipologiaAtto]");
    this.filtroRicercaAtto = undefined;
  }

  public getFiltroRicercaSempliceAtto(): FiltroRicercaAttoVO {
    console.log(
      "[FiltroRicercaAttoStore][getFiltroRicercaAtto]",
      this.filtroRicercaSempliceAtto
    );
    return this.filtroRicercaSempliceAtto;
  }

  public setFiltroRicercaSempliceAtto(
    filtroRicercaAtto: FiltroRicercaAttoVO
  ) {
    console.log(
      "[FiltroRicercaAttoStore][setFiltroRicercaAtto]",
      filtroRicercaAtto
    );
    this.filtroRicercaSempliceAtto = filtroRicercaAtto;
  }

  public setFiltroRicercaAvanzataAtto(
    filtroRicercaAtto: FiltroRicercaAttoVO
  ) {
    console.log(
      "[FiltroRicercaAttoStore][setFiltroRicercaAvanzataAtto]",
      filtroRicercaAtto
    );
    this.filtroRicercaAvanzataAtto = filtroRicercaAtto;
  }

  public getFiltroRicercaAvanzataAtto(): FiltroRicercaAttoVO {
    console.log(
      "[FiltroRicercaAttoStore][getFiltroRicercaAvanzataAtto]",
      this.filtroRicercaAvanzataAtto
    );
    return this.filtroRicercaAvanzataAtto;
  }
}
